var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
var __WEBPACK_NAMESPACE_OBJECT__ = x({ ["Remarkable"]: () => __WEBPACK_EXTERNAL_MODULE_remarkable__.Remarkable });